import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="container">
        <nav className="navbar">
          <div className="logo">
            <span className="logo-icon"><img src="/logo192.png" alt="Skyline Digital Solutions" height={100} width={200}/></span>
            <span>Skyline Digital Solutions</span>
          </div>
          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#product">Workflow</a>
            <a href="#testimonials">Clients</a>
            <a href="#contact">Contact</a>
          </div>
          <a href="#demo" className="btn">Request Demo</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;